// extracted by mini-css-extract-plugin
export var mcpContractChange = "mcp-contract-change_iEoGdZBNWRvQfJKtYSkd";
export var mcpContractChangeForm = "mcp-contract-change__form_tYXiJOrelfbjE3LBYjgS";
export var mcpContractChangeFormContent = "mcp-contract-change__form-content_WGSpiMkWijh7Ru6fkvb5";
export var mcpContractChangeHandle = "mcp-contract-change__handle_Hb0Al8fZgOJ46S0x0MLJ";